import { h } from 'preact';
import Store from 'store/store';

const Newsletter = (props) => {
	const imageRoot = Store.get()?.appData?.urls?.roots?.image || '';
	return (
		<img src={`${imageRoot}/virtualstore.gif`} {...props} />
	);
};

export default Newsletter;
